/** 销售平台操作清单与后端MenuPermissions::SALES_PLATFORM对应。只补齐同菜单读取。 */
export const salesPlatformActions = {
  experienceCamp: ['list', 'repairBindings'],
  hostedWx: ['list', 'login', 'edit', 'toggle', 'delete', 'refresh', 'logs'],
  juziAccount: ['list', 'sync'],
  sopTemplate: [
    'list',
    'create',
    'edit',
    'enable',
    'disable',
    'copy',
    'delete',
    'import',
  ],
  task: [
    'list',
    'create',
    'delete',
    'pause',
    'resume',
    'terminate',
    'retryNow',
    'confirm',
    'resend',
    'trace',
  ],
} as const;

export type SalesPlatformPage = keyof typeof salesPlatformActions;

export function salesPlatformCode(
  page: SalesPlatformPage,
  action: string,
): string {
  return `frontend${page[0].toUpperCase()}${page.slice(1)}${action[0].toUpperCase()}${action.slice(1)}`;
}

export function hasSalesPlatformPermission(
  access: Record<string, unknown>,
  page: SalesPlatformPage,
  action: string,
): boolean {
  const operations: readonly string[] = salesPlatformActions[page];
  if (!operations.includes(action)) return false;
  return Boolean(
    access[salesPlatformCode(page, action)] ||
      (action === 'list' &&
        operations.some(
          (operation) => access[salesPlatformCode(page, operation)],
        )),
  );
}

export function salesPlatformNavigation(access: Record<string, unknown>) {
  const pages = Object.keys(salesPlatformActions) as SalesPlatformPage[];
  const lists = Object.fromEntries(
    pages.map((page) => [
      salesPlatformCode(page, 'list'),
      hasSalesPlatformPermission(access, page, 'list'),
    ]),
  ) as Record<`frontend${Capitalize<SalesPlatformPage>}List`, boolean>;
  const frontendNavigation = pages.some((page) =>
    hasSalesPlatformPermission(access, page, 'list'),
  );
  const frontendAutoOpsNavigation = pages.some(
    (page) =>
      page !== 'experienceCamp' &&
      hasSalesPlatformPermission(access, page, 'list'),
  );
  return {
    frontendNavigation,
    frontendAutoOpsNavigation,
    'menu:frontendNavigation': frontendNavigation,
    'menu:frontendAutoOpsNavigation': frontendAutoOpsNavigation,
    ...lists,
  };
}
